var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ce1a12be5c9e73a03127133990dd6d8bccb89e95"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pastel-frontend@usepastel"]={id:"ce1a12be5c9e73a03127133990dd6d8bccb89e95"};
      